/* Story 1 — Audit Campaigns (Outscraper import) API client. */

import Request from './request';

const BASE = 'admin/audit-campaigns';

export default class AuditCampaignService {
  static async getList(query = {}) {
    return new Promise((resolve) => {
      Request.send({ method: 'GET', path: BASE, query })
        .then((result = {}) => {
          if (result.success && Array.isArray(result.data)) {
            return resolve({
              success: true,
              data: result.data,
              pagination: result.pagination,
              message: result.message
            });
          }
          return resolve(result);
        })
        .catch((error) =>
          resolve({ success: false, errors: [{ message: error.message || 'Failed to fetch campaigns' }] })
        );
    });
  }

  static async getById(id) {
    return new Promise((resolve) => {
      Request.send({ method: 'GET', path: `${BASE}/${id}` })
        .then((result = {}) => {
          if (result.success) {
            return resolve({ success: true, data: result.data, message: result.message });
          }
          return resolve(result);
        })
        .catch((error) =>
          resolve({ success: false, errors: [{ message: error.message || 'Failed to fetch campaign' }] })
        );
    });
  }

  static async remove(id) {
    return new Promise((resolve) => {
      Request.send({ method: 'DELETE', path: `${BASE}/${id}` })
        .then((result = {}) => {
          if (result.success) {
            return resolve({ success: true, data: result.data, message: result.message });
          }
          return resolve(result);
        })
        .catch((error) =>
          resolve({ success: false, errors: [{ message: error.message || 'Failed to delete campaign' }] })
        );
    });
  }

  static async setArchived(id, archived) {
    const action = archived ? 'archive' : 'unarchive';
    return new Promise((resolve) => {
      Request.send({ method: 'PATCH', path: `${BASE}/${id}/${action}` })
        .then((result = {}) => {
          if (result.success) {
            return resolve({ success: true, data: result.data, message: result.message });
          }
          return resolve(result);
        })
        .catch((error) =>
          resolve({
            success: false,
            errors: [{ message: error.message || 'Failed to update campaign' }]
          })
        );
    });
  }

  static async update(id, data = {}) {
    return new Promise((resolve) => {
      Request.send({ method: 'PATCH', path: `${BASE}/${id}`, data })
        .then((result = {}) => {
          if (result.success) return resolve({ success: true, data: result.data, message: result.message });
          return resolve(result);
        })
        .catch((error) =>
          resolve({ success: false, errors: [{ message: error.message || 'Failed to update campaign' }] })
        );
    });
  }

  static async create(data = {}) {
    return new Promise((resolve) => {
      Request.send({ method: 'POST', path: BASE, data })
        .then((result = {}) => {
          if (result.success) {
            return resolve({ success: true, data: result.data, message: result.message });
          }
          return resolve(result);
        })
        .catch((error) =>
          resolve({ success: false, errors: [{ message: error.message || 'Failed to create campaign' }] })
        );
    });
  }

  static async uploadFile(id, file) {
    return new Promise((resolve) => {
      const formData = new FormData();
      formData.append('file', file);
      Request.send({ method: 'POST', path: `${BASE}/${id}/upload`, data: formData })
        .then((result = {}) => {
          if (result.success) {
            return resolve({ success: true, data: result.data, message: result.message });
          }
          return resolve(result);
        })
        .catch((error) =>
          resolve({ success: false, errors: [{ message: error.message || 'Failed to upload file' }] })
        );
    });
  }

  static async confirmImport(id) {
    return new Promise((resolve) => {
      Request.send({ method: 'POST', path: `${BASE}/${id}/confirm-import` })
        .then((result = {}) => {
          if (result.success) {
            return resolve({ success: true, data: result.data, message: result.message });
          }
          return resolve(result);
        })
        .catch((error) =>
          resolve({ success: false, errors: [{ message: error.message || 'Failed to confirm import' }] })
        );
    });
  }

  // ----- Story 2: batch audits -----

  static async submitBatchAudit(campaignId, data = {}) {
    return new Promise((resolve) => {
      Request.send({ method: 'POST', path: `${BASE}/${campaignId}/batch-audits`, data })
        .then((result = {}) => {
          if (result.success) return resolve({ success: true, data: result.data, message: result.message });
          return resolve(result);
        })
        .catch((error) =>
          resolve({ success: false, errors: [{ message: error.message || 'Failed to submit batch audit' }] })
        );
    });
  }

  static async getLatestBatchJob(campaignId) {
    return new Promise((resolve) => {
      Request.send({ method: 'GET', path: `${BASE}/${campaignId}/latest-batch-job` })
        .then((result = {}) => {
          if (result.success) return resolve({ success: true, data: result.data, message: result.message });
          return resolve(result);
        })
        .catch((error) =>
          resolve({ success: false, errors: [{ message: error.message || 'Failed to fetch batch job' }] })
        );
    });
  }

  static async getBatchJob(batchJobId) {
    return new Promise((resolve) => {
      Request.send({ method: 'GET', path: `admin/audit-batch-jobs/${batchJobId}` })
        .then((result = {}) => {
          if (result.success) return resolve({ success: true, data: result.data, message: result.message });
          return resolve(result);
        })
        .catch((error) =>
          resolve({ success: false, errors: [{ message: error.message || 'Failed to fetch batch job' }] })
        );
    });
  }

  static async syncBatchResults(batchJobId) {
    return new Promise((resolve) => {
      Request.send({ method: 'POST', path: `admin/audit-batch-jobs/${batchJobId}/sync-results` })
        .then((result = {}) => {
          if (result.success) return resolve({ success: true, data: result.data, message: result.message });
          return resolve(result);
        })
        .catch((error) =>
          resolve({ success: false, errors: [{ message: error.message || 'Failed to sync batch results' }] })
        );
    });
  }

  static async getStoreAudit(storeId) {
    return new Promise((resolve) => {
      Request.send({ method: 'GET', path: `admin/audit-stores/${storeId}/audit` })
        .then((result = {}) => {
          if (result.success) return resolve({ success: true, data: result.data, message: result.message });
          return resolve(result);
        })
        .catch((error) =>
          resolve({ success: false, errors: [{ message: error.message || 'Failed to fetch audit' }] })
        );
    });
  }

  static async approveAllAudits(campaignId) {
    return new Promise((resolve) => {
      Request.send({ method: 'POST', path: `${BASE}/${campaignId}/approve-all` })
        .then((result = {}) => {
          if (result.success) return resolve({ success: true, data: result.data, message: result.message });
          return resolve(result);
        })
        .catch((error) =>
          resolve({ success: false, errors: [{ message: error.message || 'Failed to approve all' }] })
        );
    });
  }

  static async approveAudit(storeId) {
    return new Promise((resolve) => {
      Request.send({ method: 'POST', path: `admin/audit-stores/${storeId}/approve-audit` })
        .then((result = {}) => {
          if (result.success) return resolve({ success: true, data: result.data, message: result.message });
          return resolve(result);
        })
        .catch((error) =>
          resolve({ success: false, errors: [{ message: error.message || 'Failed to approve audit' }] })
        );
    });
  }

  static async regenerateAudit(storeId, data = {}) {
    return new Promise((resolve) => {
      Request.send({ method: 'POST', path: `admin/audit-stores/${storeId}/regenerate-audit`, data })
        .then((result = {}) => {
          if (result.success) return resolve({ success: true, data: result.data, message: result.message });
          return resolve(result);
        })
        .catch((error) =>
          resolve({ success: false, errors: [{ message: error.message || 'Failed to regenerate audit' }] })
        );
    });
  }

  // ----- Story 3: Saleshandy outreach -----

  static async saleshandyPreview(campaignId, data = {}) {
    return new Promise((resolve) => {
      Request.send({ method: 'POST', path: `${BASE}/${campaignId}/saleshandy/preview`, data })
        .then((result = {}) => {
          if (result.success) return resolve({ success: true, data: result.data, message: result.message });
          return resolve(result);
        })
        .catch((error) =>
          resolve({ success: false, errors: [{ message: error.message || 'Failed to preview' }] })
        );
    });
  }

  static async saleshandySend(campaignId, data = {}, idempotencyKey) {
    return new Promise((resolve) => {
      Request.send({
        method: 'POST',
        path: `${BASE}/${campaignId}/saleshandy/send`,
        data,
        headers: { 'Idempotency-Key': idempotencyKey }
      })
        .then((result = {}) => {
          if (result.success) return resolve({ success: true, data: result.data, message: result.message });
          return resolve(result);
        })
        .catch((error) =>
          resolve({ success: false, errors: [{ message: error.message || 'Failed to queue send' }] })
        );
    });
  }

  static async getSaleshandyImports(campaignId, query = {}) {
    return new Promise((resolve) => {
      Request.send({ method: 'GET', path: `${BASE}/${campaignId}/saleshandy-imports`, query })
        .then((result = {}) => {
          if (result.success) return resolve({ success: true, data: result.data, message: result.message });
          return resolve(result);
        })
        .catch((error) =>
          resolve({ success: false, errors: [{ message: error.message || 'Failed to fetch imports' }] })
        );
    });
  }

  static async getSaleshandyImportJob(importJobId) {
    return new Promise((resolve) => {
      Request.send({ method: 'GET', path: `admin/saleshandy-import-jobs/${importJobId}` })
        .then((result = {}) => {
          if (result.success) return resolve({ success: true, data: result.data, message: result.message });
          return resolve(result);
        })
        .catch((error) =>
          resolve({ success: false, errors: [{ message: error.message || 'Failed to fetch import job' }] })
        );
    });
  }

  static async refreshSaleshandyImport(importJobId) {
    return new Promise((resolve) => {
      Request.send({ method: 'POST', path: `admin/saleshandy-import-jobs/${importJobId}/refresh` })
        .then((result = {}) => {
          if (result.success) return resolve({ success: true, data: result.data, message: result.message });
          return resolve(result);
        })
        .catch((error) =>
          resolve({ success: false, errors: [{ message: error.message || 'Failed to refresh import' }] })
        );
    });
  }

  static async resubmitSaleshandyImport(importJobId) {
    return new Promise((resolve) => {
      Request.send({ method: 'POST', path: `admin/saleshandy-import-jobs/${importJobId}/resubmit` })
        .then((result = {}) => {
          if (result.success) return resolve({ success: true, data: result.data, message: result.message });
          return resolve(result);
        })
        .catch((error) =>
          resolve({ success: false, errors: [{ message: error.message || 'Failed to resubmit import' }] })
        );
    });
  }

  static async getSaleshandyImportStores(importJobId) {
    return new Promise((resolve) => {
      Request.send({ method: 'GET', path: `admin/saleshandy-import-jobs/${importJobId}/stores` })
        .then((result = {}) => {
          if (result.success) return resolve({ success: true, data: result.data, message: result.message });
          return resolve(result);
        })
        .catch((error) =>
          resolve({ success: false, errors: [{ message: error.message || 'Failed to fetch import stores' }] })
        );
    });
  }

  static async getStores(id, query = {}) {
    return new Promise((resolve) => {
      Request.send({ method: 'GET', path: `${BASE}/${id}/stores`, query })
        .then((result = {}) => {
          if (result.success && Array.isArray(result.data)) {
            return resolve({
              success: true,
              data: result.data,
              pagination: result.pagination,
              message: result.message
            });
          }
          return resolve(result);
        })
        .catch((error) =>
          resolve({ success: false, errors: [{ message: error.message || 'Failed to fetch stores' }] })
        );
    });
  }
}
